export const LIST_PURPOSE_REQUEST = 'LIST_PURPOSE_REQUEST';
export const LIST_PURPOSE_REQUEST_SUCCESS = 'LIST_PURPOSE_REQUEST_SUCCESS';
export const LIST_PURPOSE_REQUEST_FAILURE = 'LIST_PURPOSE_REQUEST_FAILURE';

export const CLEAR_PURPOSE_LIST = 'CLEAR_PURPOSE_LIST';